import { ICartState } from './stateInterface';

export default (): ICartState => ({
    id: '0',
    dailyPicks: [],
    classicPicks: [],
});
